import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { INDRASidebarComponent } from './sidebar.indra.component';
import { LoadingModule } from './../../shared/loading/loading.module';

@NgModule({
	imports: [CommonModule, LoadingModule],
	declarations: [INDRASidebarComponent],
	exports: [INDRASidebarComponent]
})
export class SidebarModule {}
